export const pl = {
    LEFT: 'W lewo: przejście do poprzedniego dnia.',
    RIGHT: 'W prawo: przejście do następnego dnia.',
    DOWN: 'W dół: przejście do następnej linii.',
    UP: 'W górę: przejście do poprzedniego wiersza.',
    PGUP: 'W górę: przejście do poprzedniego miesiąca.',
    PGDOWN: 'PgDown: przejść na następny miesiąc.',
    HOME: 'Domy: przejście do poprzedniego roku.',
    END: 'Koniec: przenieść na następny rok.',
    ESC: 'Mca/dziś/zamknij: zamknięcie kalendarz. Instrukcje',
    TITLE: 'Klawiatura '
};
